var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icon_-_True",
    width: 24,
    height: 24,
    "data-name": "Icon - True",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-3{fill:#fff}.cls-1{opacity:0}.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M0 0h24v24H0z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "frame",
    d: "M0 0h16v16H0z",
    className: "cls-1",
    transform: "translate(4 4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2592",
    "data-name": "Group 2592",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#f54b5e",
    "data-name": "Oval 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check001_-_E055",
    d: "M-4.925-40.33l-6 6s6.125-5.927 6-6z",
    className: "cls-3",
    "data-name": "check001 - E055",
    transform: "translate(15.923 45.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check001_-_E055-2",
    d: "M-10.921-40.33l6 6s-6.124-5.927-6-6z",
    className: "cls-3",
    "data-name": "check001 - E055",
    transform: "translate(15.923 45.33)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotTrue);
export default __webpack_public_path__ + "static/media/icon-not-true.668b474e85be502f07c47c9d0b7aabf9.svg";
export { ForwardRef as ReactComponent };